import React from 'react';
import { IStoreState } from '../../../reducers/types';
import { useSelector } from 'react-redux';
import { Column, Row, LoadingSpinner, ContrastBox } from '@mattilsynet/mt-ui';
import '../style.css';
import { AndreDeltakere, MattilsynetDeltakere, VirksomhetDeltakere } from '../../../features/deltakere';
export const DeltakereSlide = () => {
  const isLoading = useSelector((state: IStoreState) => state.kvittering.loading);
  const renderContent = () => {
    if (isLoading) {
      return <Row center>
          <LoadingSpinner title={'Laster deltagerer...'} small />
        </Row>;
    }
    return <>
        <ContrastBox noBorders backgroundColor="white" data-sentry-element="ContrastBox" data-sentry-source-file="deltakere-slide.tsx">
          <VirksomhetDeltakere data-sentry-element="VirksomhetDeltakere" data-sentry-source-file="deltakere-slide.tsx" />
        </ContrastBox>

        <ContrastBox noBorders backgroundColor="white" data-sentry-element="ContrastBox" data-sentry-source-file="deltakere-slide.tsx">
          <MattilsynetDeltakere data-sentry-element="MattilsynetDeltakere" data-sentry-source-file="deltakere-slide.tsx" />
        </ContrastBox>

        <ContrastBox noBorders backgroundColor="white" data-sentry-element="ContrastBox" data-sentry-source-file="deltakere-slide.tsx">
          <AndreDeltakere data-sentry-element="AndreDeltakere" data-sentry-source-file="deltakere-slide.tsx" />
        </ContrastBox>
      </>;
  };
  return <Column spacing={3} fluid key={2} data-sentry-element="Column" data-sentry-component="DeltakereSlide" data-sentry-source-file="deltakere-slide.tsx">
      <Row className="title" data-sentry-element="Row" data-sentry-source-file="deltakere-slide.tsx">
        <h1>Deltakere</h1>
      </Row>
      {renderContent()}
    </Column>;
};